<template>
  <ul class="card-overview">
    <li
      v-for="(field, index) in fields"
      :key="`card-overview-field-${index}`"
      :class="[
        'card-overview__field',
        { 'card-overview__field--hidden-on-mobile': field.hiddenOnMobile },
      ]"
    >
      <p class="card-overview__label">{{ field.label }}</p>
      <span class="card-overview__tag card-overview__tag--grey">{{ field.data }}</span>
      <div
        v-if="field.hasDaysCount && deal.days_in_status_group"
        class="card-overview__text-wrapper"
      >
        <span class="card-overview__since">{{ $t('DASHBOARD.CARD.EXPANDED.OVERVIEW.SINCE') }}</span>
        <span class="card-overview__tag" :class="onlineSinceCustomClass">
          {{ getOnlineSince(deal) }}
        </span>
      </div>
    </li>
    <HdButton class="card-overview__button" @click="openConnectDealInNewTab()">
      {{ $t('DASHBOARD.CARD.EXPANDED.OVERVIEW.CTA_LABEL') }}
    </HdButton>
  </ul>
</template>

<script>
import { HdButton } from 'homeday-blocks';

export default {
  name: 'CardOverview',
  components: { HdButton },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    onlineSinceCustomClass() {
      const { days_in_status_group: daysInStatusGroup } = this.deal;
      const baseClass = 'card-overview__tag';
      const colorClasses = {
        grey: daysInStatusGroup < 8,
        yellow: daysInStatusGroup >= 8 && daysInStatusGroup < 15,
        red: daysInStatusGroup >= 15,
      };

      const onlineSinceCustomClass = Object.entries(colorClasses)
        .filter(([_key, value]) => value)
        .map(([key]) => `${baseClass}--${key}`);

      return onlineSinceCustomClass;
    },
    fields() {
      return [
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.OVERVIEW.TYPE'),
          data: this.$t(`DASHBOARD.TAGS.${this.deal?.status_group?.toUpperCase()}`),
          hasDaysCount: true,
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.OVERVIEW.STATUS'),
          data: this.$t(`DASHBOARD.CARD.STATUS.${this.deal?.status?.toUpperCase()}`),
        },
        {
          label: this.$t('DASHBOARD.CARD.EXPANDED.OVERVIEW.APPOINTMENT_COORDINATION'),
          data:
            this.deal?.property?.viewing_type &&
            this.$t(
              `DASHBOARD.CARD.EXPANDED.OVERVIEW.VIEWING_TYPE.${this.deal?.property?.viewing_type?.toUpperCase()}`,
            ),
          hiddenOnMobile: true,
        },
      ].filter((field) => field.data);
    },
  },
  methods: {
    getOnlineSince(deal) {
      return this.$tc('DASHBOARD.CARD.EXPANDED.OVERVIEW.TIME_ONLINE', deal.days_in_status_group, {
        daysOnline: deal.days_in_status_group,
      });
    },
    openConnectDealInNewTab() {
      window.open(`${process.env.VUE_APP_HD_CONNECT}/crm/deals/${this.deal.uid}`, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.card-overview {
  &__field {
    align-items: center;
    display: flex;
    flex-wrap: wrap;

    &--hidden-on-mobile {
      display: none;

      @include for('tablet') {
        display: flex;
      }
    }
  }

  &__label,
  &__since {
    @include font('DS-90');
    font-weight: 600;
    margin: $sp-s;

    @include for('tablet') {
      @include font('DS-100');
      margin: $sp-m $sp-s;
    }
  }

  &__since {
    @include for('tablet') {
      font-weight: 500;
    }
  }

  &__label {
    margin-left: 0;
  }

  &__text-wrapper {
    align-items: center;
    display: flex;
  }

  span:not(&__label):not(&__since) {
    @include font('DS-80');
    border-radius: $sp-s;
    margin: $sp-xs 0;

    @include for('tablet') {
      @include font('DS-100');
    }
  }

  &__tag {
    display: flex;
    align-items: center;
    padding: $sp-xxs $sp-s;

    @include for('tablet') {
      padding: $sp-xs $sp-m;
    }
  }

  &__tag--grey {
    background-color: getShade($quaternary-color, 50);
  }

  &__tag--yellow {
    color: getShade($tertiary-color, 110);
    background-color: getShade($tertiary-color, 60);
  }

  &__tag--red {
    color: $error-color;
    background-color: getShade($error-color, 50);
  }

  &__button {
    display: none;

    @include for('tablet') {
      display: flex;
      margin-top: $sp-m;
      width: 100%;
    }
  }
}
</style>
